import axios from '../../index'
import qs from 'qs'
/**
 * @description 采购商订单详情（待支付 待收货 全部）
 * @author hd
 * @date 2020-6-28
 * @export
 *
 */
export function loadOrderList (params) {
  return axios.post('/order/load-order-list', qs.stringify(params))
}
/**
 * @description 确定收货
 * @author hd
 * @date 2020-7-3
 * @export
 *
 */
export function orderOk (params) {
  return axios.post('/order/order-confirm', qs.stringify(params))
}
/**
 * @description 确认订单
 * @author hd
 * @date 2020-7-3
 * @export
 *
 */
export function orderConfirm (params) {
  return axios.post('/order/chgreplacestate', qs.stringify(params))
}
/**
 * @description 取消订单
 * @author hd
 * @date 2020-7-3
 * @export
 *
 */
export function orderCancel (params) {
  return axios.post('/order/cancel-order', qs.stringify(params))
}
/**
 * @description 再次购买
 * @author hd
 * @date 2020-7-3
 * @export
 *
 */
export function againBuy (params) {
  return axios.post('/cart/buy', qs.stringify(params))
}
/**
 * @description 采购商订单详情
 * @author hd
 * @date 2020-7-3
 * @export
 *
 */
export function loadOrderDetail (params) {
  return axios.post('/order/load-order-detail', qs.stringify(params))
}
